import constants from '../../../common/restService/constant';
import GatewayGet from '../CommonServices/GatewayGet'

let props = {}
let inputObj = {}
let InputJSONString = ''
props['query'] = constants.serviceRoot
props['headers'] = constants.serviceHeaders

export const GetSCACData = async () => {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "XDOCK_EH_GET_SCAC";
    inputObj["Input"] = "";
    props.input = inputObj;
    const result = await GatewayGet(props, props.input)
    return result
}

export const GetSearchData = async (inputData) => {
    InputJSONString = JSON.stringify(inputData)
    inputObj['Activity'] = 'XDOCK_EH_GET'
    inputObj['Input'] = InputJSONString
    props.input = inputObj
    const result = await GatewayGet(props, props.input)
    return result
}
